import React, {Component} from "react";
import { Select2 } from "select2-react-component";
import {valueFromId} from '../../Utils/CommonFunctions';

class DropDownSearch extends Component{

	

	render(){
		const {options,values,changeHandler,isDisable,searchCount} = this.props;
		// console.log(options, values,valueFromId(options, values));
		//console.log('sssssss',valueFromId(options, values));
		//console.log("values===",options)
		return (
			<Select2 
				data={options}
	            value={values}
	            value={valueFromId(options, values)}
	            update={value => changeHandler(value)}
	            disabled={isDisable}
	            minCountForSearch={searchCount}
	            >
	        </Select2>
		);
	}
}

DropDownSearch.defaultProps = {
    isDisable: false,
    searchCount: 1
}

export default DropDownSearch;